import { Field } from 'formik';
import { calculateAge, formatPhoneNumber } from '../common';
import pmsConstants from '../../pmsConstants';
import DatePicker from "react-datepicker";
import { useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";

export default function BasicUserSettings({ disabled, errors, touched, values, handleChange, prefix, handleBlur, editPage, setFieldValue, dispatch,
    patientEdit, userType }) {

    const [startDate, setStartDate] = useState(() => {
        if (values.dateOfBirth) {
            return Date.parse((values.dateOfBirth));
        } else {
            return new Date();
        }
    });

    const handleGenderChange = (genderStr, setFieldValue) => {
        setFieldValue("gender", genderStr)
    }

    const handleDOBChange = (selectedDate, setFieldValue) => {
        setFieldValue('dateOfBirth', selectedDate);
        setStartDate(selectedDate);
        var patientAge = calculateAge(selectedDate);
        setFieldValue('age', patientAge);
    }

    const handlePhoneNumInput = (e, setFieldValue) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        setFieldValue('phoneNo', formattedPhoneNumber);
    };

    return (
        <div className='space-y-4 w-full'>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                <div>
                    <label for="firstname" className='block text-sm font-medium text-gray-700 mb-1'>First Name</label>
                    <div className="mb-3">
                        <Field type="text" id={`${prefix}-input_firstname`} name="firstname" required
                            onBlur={handleBlur}
                            className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.firstname && touched.firstname ? 'border-red-500' : ''}`}
                        />
                        {errors.firstname && touched.firstname ? (
                            <div className="text-red-500 text-sm mt-1">{errors.firstname}</div>
                        ) : null}
                    </div>
                </div>
                <div>
                    <label for="lastname" className='block text-sm font-medium text-gray-700 mb-1'>Last Name</label>
                    <div className="mb-3">
                        <Field type="text" id={`${prefix}-input_lastname`} name="lastname" required
                            onBlur={handleBlur}
                            className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.lastname && touched.lastname ? 'border-red-500' : ''}`}
                        />
                        {errors.lastname && touched.lastname ? (
                            <div className="text-red-500 text-sm mt-1">{errors.lastname}</div>
                        ) : null}
                    </div>
                </div>
            </div>
            {(patientEdit) &&
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 w-full">
                    <div className="lg:col-span-4">
                        <label for="gender" className='block text-sm font-medium text-gray-700 mb-1'>Gender</label>
                        <div className="mb-3">
                            <Field as="select" name="gender" aria-label="Gender"
                                defaultValue={values.gender}
                                onChange={(e) => handleGenderChange(e.target.value, setFieldValue)}
                                className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.gender && touched.gender ? 'border-red-500' : ''}`}
                            >
                                <option value="">Select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Prefer not to disclose">Prefer not to disclose</option>
                            </Field>
                            {errors.gender && touched.gender ? (
                                <div className="text-red-500 text-sm mt-1">{errors.gender}</div>
                            ) : null}
                        </div>
                    </div>
                    <div className="lg:col-span-3">
                        <label for="patientDob" className='block text-sm font-medium text-gray-700 mb-1'>Date of Birth</label>
                        <div className="mb-3">
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => handleDOBChange(date, setFieldValue)}
                                className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.patientDob && touched.patientDob ? 'border-red-500' : ''}`}
                            />
                        </div>
                    </div>
                    <div className="lg:col-span-3">
                        <label for="age" className='block text-sm font-medium text-gray-700 mb-1'>Age</label>
                        <div className="mb-3">
                            <Field type="text" id={`${prefix}-input_age`} name="age" disabled
                                onBlur={handleBlur}
                                className={`w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 ${errors.age && touched.age ? 'border-red-500' : ''}`} />
                            {errors.age && touched.age ? (
                                <div className="text-red-500 text-sm mt-1">{errors.age}</div>
                            ) : null}
                        </div>
                    </div>
                </div>}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                {userType !== pmsConstants.USER_TYPE_PATIENT &&
                    <div>
                        <label for="username" className='block text-sm font-medium text-gray-700 mb-1'>Username</label>
                        <div className="mb-3">
                            <Field type="text" id={`${prefix}-input_username`} name="username" required
                                disabled
                                className={`w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 ${errors.username ? 'border-red-500' : ''}`} />
                            {errors.username ? (
                                <div className="text-red-500 text-sm mt-1">{errors.username}</div>
                            ) : null}
                        </div>
                    </div>}

                <div>
                    <label for="userEmail" className='block text-sm font-medium text-gray-700 mb-1'>Email</label>
                    <div className="mb-3">
                        <Field type="email" id={`${prefix}-input_userEmail`} name="userEmail"
                            disabled={patientEdit}
                            className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.userEmail && touched.userEmail ? 'border-red-500' : ''}`} />
                        {errors.userEmail && touched.userEmail ? (
                            <div className="text-red-500 text-sm mt-1">{errors.userEmail}</div>
                        ) : null}
                    </div>
                </div>

                <div>
                    <label for="firstname" className='block text-sm font-medium text-gray-700 mb-1'>Phone Number</label>
                    <div className="mb-3">
                        <Field type="text" id={`${prefix}-input_userPhoneNo`} name="phoneNo"
                            onChange={(e) => handlePhoneNumInput(e, setFieldValue)}
                            className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.phoneNo && touched.phoneNo ? 'border-red-500' : ''}`} />
                        {errors.phoneNo && touched.phoneNo ? (
                            <div className="text-red-500 text-sm mt-1">{errors.phoneNo}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}